var App = App || {};

App.OffCanvases = (function () {
    'use strict';

    const GLOBAL_MENU_SELECTOR = '.offcanvas-global-menu';
    const BACKDROP_SELECTOR = '.offcanvas-backdrop';
    const GLOBAL_OPEN_CLASS = 'global-open';
    const SEARCH_MENU_SELECTOR = '.offcanvas-search';

    const toggleGlobalBackdrop = (offcanvasElement, isOpen) => {
        if ((offcanvasElement instanceof Element) && offcanvasElement.matches(GLOBAL_MENU_SELECTOR)) {
            const backdrop = document.querySelector(BACKDROP_SELECTOR);
            if (backdrop) {
                backdrop.classList.toggle(GLOBAL_OPEN_CLASS, isOpen);
            }
        }
    };

    const handleSearchFocus = (offcanvasElement) => {
        if ((offcanvasElement instanceof Element) && offcanvasElement.matches(SEARCH_MENU_SELECTOR)) {
            offcanvasElement.querySelector("input").focus();
        }
    };

    document.addEventListener('show.bs.offcanvas', event => {
        setTimeout(function () {
            toggleGlobalBackdrop(event.target, true);
        }, 0);
    });

    document.addEventListener('hidden.bs.offcanvas', event => {
        toggleGlobalBackdrop(event.target, false);
    });

    document.addEventListener('shown.bs.offcanvas', event => {
        handleSearchFocus(event.target);
    });

    return {};
})();
